import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "program-short-name" }
const _hoisted_2 = { class: "program-logo-row" }
const _hoisted_3 = { class: "program-logo-wrapper" }
const _hoisted_4 = ["src", "onError"]
const _hoisted_5 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_6 = { class: "release-tiers-section" }
const _hoisted_7 = { class: "upload-queue-hint" }
const _hoisted_8 = { class: "upload-queue-original" }
const _hoisted_9 = ["accept"]
const _hoisted_10 = { class: "upload-modal-file-list" }
const _hoisted_11 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_12 = { class: "upload-modal-file-list" }
const _hoisted_13 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_14 = { class: "upload-modal-file-list" }
const _hoisted_15 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_16 = { class: "upload-modal-file-list" }
const _hoisted_17 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_18 = {
  key: 1,
  class: "upload-progress-list"
}
const _hoisted_19 = { class: "progress-text" }
const _hoisted_20 = { class: "program-short-name" }
const _hoisted_21 = {
  key: 0,
  class: "program-logo-row"
}
const _hoisted_22 = { class: "program-logo-wrapper program-logo-wrapper-preview" }
const _hoisted_23 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderWithMenu, {
        title: "Релизы",
        scrolled: _ctx.headerScrolled
      }, null, 8, ["scrolled"]),
      _createVNode(_component_ion_content, {
        class: _normalizeClass([_ctx.isMobile ? 'main-background' : 'liga-web-background']),
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card, { class: "admin-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openNewProgramModal()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: _ctx.add
                      }, null, 8, ["icon"]),
                      _cache[34] || (_cache[34] = _createTextVNode(" Создать новую программу ", -1))
                    ]),
                    _: 1
                  }),
                  (_ctx.showGoogleDriveSyncButton)
                    ? (_openBlock(), _createBlock(_component_ion_button, {
                        key: 0,
                        expand: "block",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.syncWithGoogleDrive())),
                        disabled: _ctx.syncing
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: _ctx.cloudDownloadOutline
                          }, null, 8, ["icon"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.syncing ? 'Синхронизация...' : 'Синхронизировать с Google Drive'), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programs, (program) => {
            return (_openBlock(), _createBlock(_component_ion_card, {
              class: "admin-card",
              key: program.id
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(program.programName), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("p", _hoisted_1, _toDisplayString(program.shortName), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("img", {
                          src: _ctx.programLogoUrl(program.shortName),
                          alt: "Логотип программы",
                          class: "program-logo-img",
                          onError: ($event: any) => (_ctx.onLogoError(program.shortName))
                        }, null, 40, _hoisted_4)
                      ]),
                      _createVNode(_component_ion_button, {
                        fill: "clear",
                        size: "small",
                        class: "program-logo-edit-btn",
                        onClick: ($event: any) => (_ctx.openLogoModal(program))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: _ctx.imageOutline
                          }, null, 8, ["icon"]),
                          _cache[35] || (_cache[35] = _createTextVNode(" Изменить ", -1))
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      onClick: ($event: any) => (_ctx.openNewReleaseModal(program))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: _ctx.add
                        }, null, 8, ["icon"]),
                        _cache[36] || (_cache[36] = _createTextVNode(" Создать релиз ", -1))
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    (program.fullReleases && program.fullReleases.length)
                      ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(program.fullReleases, (release) => {
                              return (_openBlock(), _createBlock(_component_ion_item, {
                                key: release.id,
                                detail: false,
                                button: "",
                                onClick: ($event: any) => (_ctx.selectRelease(program, release))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h2", null, _toDisplayString(program.programName) + " " + _toDisplayString(release.releaseName), 1),
                                      _createElementVNode("p", null, _toDisplayString(release.visible ? 'Видимый' : 'Скрытый'), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_icon, {
                                    slot: "end",
                                    icon: _ctx.chevronForward
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createElementBlock("p", _hoisted_5, "Нет релизов для этой программы."))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showNewProgramModal,
            onDidDismiss: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeNewProgramModal())),
            class: "admin-releases-modal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                          _createTextVNode("Новая программа", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeNewProgramModal()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_header, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_title, null, {
                            default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                              _createTextVNode("Создать программу", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                label: "Название программы",
                                "label-placement": "stacked",
                                modelValue: _ctx.newProgramName,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newProgramName) = $event)),
                                placeholder: "Например: HypeDance"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_input, {
                                label: "Короткое название (латиницей)",
                                "label-placement": "stacked",
                                modelValue: _ctx.newProgramShortName,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newProgramShortName) = $event)),
                                placeholder: "Например: HD"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_button, {
                            expand: "block",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createNewProgram())),
                            disabled: !_ctx.newProgramName || !_ctx.newProgramShortName || _ctx.creatingProgram
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.creatingProgram ? 'Создание...' : 'Создать программу'), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showNewReleaseModal,
            onDidDismiss: _cache[12] || (_cache[12] = ($event: any) => (_ctx.closeNewReleaseModal())),
            class: "admin-releases-modal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                          _createTextVNode("Новый релиз", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeNewReleaseModal()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_content, null, {
                default: _withCtx(() => [
                  (_ctx.selectedProgram)
                    ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.selectedProgram.programName), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_input, {
                                    label: "Номер релиза",
                                    "label-placement": "stacked",
                                    modelValue: _ctx.newReleaseName,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newReleaseName) = $event)),
                                    placeholder: "Например: 1 или 10"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_input, {
                                    label: "Описание (опционально)",
                                    "label-placement": "stacked",
                                    modelValue: _ctx.newReleaseDescription,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newReleaseDescription) = $event)),
                                    placeholder: "Описание релиза"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_toggle, {
                                    modelValue: _ctx.newReleaseVisible,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newReleaseVisible) = $event))
                                  }, {
                                    default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                      _createTextVNode("Видимый для всех пользователей", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.createNewRelease())),
                                disabled: !_ctx.newReleaseName || _ctx.creating
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.creating ? 'Создание...' : 'Создать'), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showUploadModal,
            onDidDismiss: _cache[27] || (_cache[27] = ($event: any) => (_ctx.closeUploadModal())),
            class: "admin-releases-modal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                          _createTextVNode("Загрузка контента", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.closeUploadModal()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.selectedRelease && _ctx.selectedProgram)
                ? (_openBlock(), _createBlock(_component_ion_content, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.selectedProgram.programName) + " " + _toDisplayString(_ctx.selectedRelease.releaseName), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, { class: "release-catalog-settings" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, {
                                lines: "full",
                                class: "transparent-item"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_toggle, {
                                    modelValue: _ctx.editReleaseVisible,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editReleaseVisible) = $event)),
                                    disabled: !_ctx.selectedRelease
                                  }, {
                                    default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                      _createTextVNode("Видимый в каталоге", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["modelValue", "disabled"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, {
                                lines: "full",
                                class: "transparent-item"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_input, {
                                    modelValue: _ctx.editReleasePriceRub,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editReleasePriceRub) = $event)),
                                    modelModifiers: { number: true },
                                    label: "Цена, ₽ (0 — не продаётся отдельно; при тарифах ниже — запасной вариант)",
                                    "label-placement": "floating",
                                    type: "number",
                                    inputmode: "decimal",
                                    disabled: !_ctx.selectedRelease
                                  }, null, 8, ["modelValue", "disabled"])
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_6, [
                                _cache[46] || (_cache[46] = _createElementVNode("h3", null, "Тарифы покупки", -1)),
                                _cache[47] || (_cache[47] = _createElementVNode("p", { class: "release-tiers-hint" }, "Если заданы тарифы, используется минимальная цена из доступных пользователю. Роль ограничивает видимость тарифа.", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editReleasePriceTiers, (t, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: i,
                                    class: "tier-row"
                                  }, [
                                    _createVNode(_component_ion_input, {
                                      modelValue: t.name,
                                      "onUpdate:modelValue": ($event: any) => ((t.name) = $event),
                                      label: "Название",
                                      "label-placement": "stacked",
                                      placeholder: "Стандарт"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_ion_input, {
                                      modelValue: t.amountRub,
                                      "onUpdate:modelValue": ($event: any) => ((t.amountRub) = $event),
                                      modelModifiers: { number: true },
                                      label: "₽",
                                      "label-placement": "stacked",
                                      type: "number",
                                      min: "0"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_ion_select, {
                                      modelValue: t.requiredAuthorityName,
                                      "onUpdate:modelValue": ($event: any) => ((t.requiredAuthorityName) = $event),
                                      interface: "popover",
                                      placeholder: "Роль",
                                      "cancel-text": "Отмена"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_select_option, { value: null }, {
                                          default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                                            _createTextVNode("—", -1)
                                          ]))]),
                                          _: 1
                                        }),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authorities, (a) => {
                                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                                            key: a.name,
                                            value: a.name
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(a.description || a.name), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_ion_button, {
                                      fill: "clear",
                                      size: "small",
                                      onClick: ($event: any) => (_ctx.removeReleaseTier(i))
                                    }, {
                                      default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                        _createTextVNode("×", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]))
                                }), 128)),
                                _createVNode(_component_ion_button, {
                                  fill: "outline",
                                  size: "small",
                                  onClick: _ctx.addReleaseTier
                                }, {
                                  default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                    _createTextVNode("+ Тариф", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                onClick: _ctx.saveReleaseCatalogSettings,
                                disabled: !_ctx.selectedRelease || _ctx.savingReleaseCatalog
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.savingReleaseCatalog ? 'Сохранение…' : 'Сохранить цену и видимость'), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              (_ctx.uploadQueue.length > 0)
                                ? (_openBlock(), _createBlock(_component_ion_card, {
                                    key: 0,
                                    color: "tertiary",
                                    class: "upload-queue-card"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_card_header, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_card_title, null, {
                                            default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                              _createTextVNode("Имена на сервере", -1)
                                            ]))]),
                                            _: 1
                                          }),
                                          _createElementVNode("p", _hoisted_7, [
                                            _cache[49] || (_cache[49] = _createTextVNode(" При необходимости измените имя каждого файла (включая ведущие нули), затем нажмите «Загрузить». ", -1)),
                                            (_ctx.uploadQueueType === 'music' || _ctx.uploadQueueType === 'video')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(" Расширение совпадает с исходным файлом и не меняется. ")
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_card_content, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_list, {
                                            lines: "full",
                                            class: "transparent-list"
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadQueue, (q, qIdx) => {
                                                return (_openBlock(), _createBlock(_component_ion_item, {
                                                  key: 'q-' + qIdx
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("p", _hoisted_8, _toDisplayString(q.file.name), 1),
                                                        _createVNode(_component_ion_input, {
                                                          modelValue: q.targetName,
                                                          "onUpdate:modelValue": ($event: any) => ((q.targetName) = $event),
                                                          label: "Сохранить как",
                                                          "label-placement": "stacked",
                                                          placeholder: q.file.name,
                                                          onIonInput: ($event: any) => (_ctx.onReleaseUploadTargetNameInput(q, $event))
                                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onIonInput"])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_button, {
                                            expand: "block",
                                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.flushUploadQueue())),
                                            disabled: _ctx.uploadQueueFlushing
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.uploadQueueFlushing ? 'Загрузка…' : 'Загрузить'), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"]),
                                          _createVNode(_component_ion_button, {
                                            expand: "block",
                                            fill: "clear",
                                            color: "medium",
                                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.clearUploadQueue())),
                                            disabled: _ctx.uploadQueueFlushing
                                          }, {
                                            default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                              _createTextVNode(" Отмена ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                      _createElementVNode("h2", null, "Музыка", -1),
                                      _createElementVNode("p", null, "Аудио файлы (конвертируются в MP3)", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.selectFiles('music')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: _ctx.musicalNotesOutline
                                  }, null, 8, ["icon"]),
                                  _cache[52] || (_cache[52] = _createTextVNode(" Загрузить музыку ", -1))
                                ]),
                                _: 1
                              }),
                              _createElementVNode("input", {
                                type: "file",
                                ref: "musicInput",
                                multiple: "",
                                accept: _ctx.adminAudioFileAccept,
                                style: {"display":"none"},
                                onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.uploadFiles('music', $event)))
                              }, null, 40, _hoisted_9),
                              _createElementVNode("div", _hoisted_10, [
                                (_ctx.releaseMediaFiles.music.length)
                                  ? (_openBlock(), _createBlock(_component_ion_list, {
                                      key: 0,
                                      class: "transparent-list"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.releaseMediaFiles.music, (f) => {
                                          return (_openBlock(), _createBlock(_component_ion_item, {
                                            key: f.id,
                                            lines: "full"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, null, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("h3", null, _toDisplayString(f.name), 1),
                                                  _createElementVNode("p", null, _toDisplayString(_ctx.formatFileSize(f.weight)), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_ion_button, {
                                                slot: "end",
                                                fill: "clear",
                                                onClick: ($event: any) => (_ctx.promptRenameFile('music', f))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                                                ]),
                                                _: 1
                                              }, 8, ["onClick"]),
                                              _createVNode(_component_ion_button, {
                                                slot: "end",
                                                fill: "clear",
                                                color: "danger",
                                                onClick: ($event: any) => (_ctx.confirmDeleteFile('music', f))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                                ]),
                                                _: 1
                                              }, 8, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }))
                                  : (!_ctx.releaseMediaLoading)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Нет загруженных файлов"))
                                    : _createCommentVNode("", true)
                              ]),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                                      _createElementVNode("h2", null, "Видео", -1),
                                      _createElementVNode("p", null, "Видео файлы (конвертируются для стриминга)", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.selectFiles('video')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: _ctx.videocamOutline
                                  }, null, 8, ["icon"]),
                                  _cache[54] || (_cache[54] = _createTextVNode(" Загрузить видео ", -1))
                                ]),
                                _: 1
                              }),
                              _createElementVNode("input", {
                                type: "file",
                                ref: "videoInput",
                                multiple: "",
                                accept: "video/*",
                                style: {"display":"none"},
                                onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.uploadFiles('video', $event)))
                              }, null, 544),
                              _createElementVNode("div", _hoisted_12, [
                                (_ctx.releaseMediaFiles.video.length)
                                  ? (_openBlock(), _createBlock(_component_ion_list, {
                                      key: 0,
                                      class: "transparent-list"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.releaseMediaFiles.video, (f) => {
                                          return (_openBlock(), _createBlock(_component_ion_item, {
                                            key: f.id,
                                            lines: "full"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, null, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("h3", null, _toDisplayString(f.name), 1),
                                                  _createElementVNode("p", null, _toDisplayString(_ctx.formatFileSize(f.weight)), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_ion_button, {
                                                slot: "end",
                                                fill: "clear",
                                                onClick: ($event: any) => (_ctx.promptRenameFile('video', f))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                                                ]),
                                                _: 1
                                              }, 8, ["onClick"]),
                                              _createVNode(_component_ion_button, {
                                                slot: "end",
                                                fill: "clear",
                                                color: "danger",
                                                onClick: ($event: any) => (_ctx.confirmDeleteFile('video', f))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                                ]),
                                                _: 1
                                              }, 8, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }))
                                  : (!_ctx.releaseMediaLoading)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Нет загруженных файлов"))
                                    : _createCommentVNode("", true)
                              ]),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                                      _createElementVNode("h2", null, "Гайд (PDF)", -1),
                                      _createElementVNode("p", null, "PDF файл (конвертируется в изображения)", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.selectFiles('guide')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: _ctx.documentTextOutline
                                  }, null, 8, ["icon"]),
                                  _cache[56] || (_cache[56] = _createTextVNode(" Загрузить гайд ", -1))
                                ]),
                                _: 1
                              }),
                              _createElementVNode("input", {
                                type: "file",
                                ref: "guideInput",
                                accept: ".pdf,application/pdf",
                                style: {"display":"none"},
                                onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.uploadFiles('guide', $event)))
                              }, null, 544),
                              _createElementVNode("div", _hoisted_14, [
                                (_ctx.releaseMediaFiles.guide.length)
                                  ? (_openBlock(), _createBlock(_component_ion_list, {
                                      key: 0,
                                      class: "transparent-list"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.releaseMediaFiles.guide, (f) => {
                                          return (_openBlock(), _createBlock(_component_ion_item, {
                                            key: f.id,
                                            lines: "full"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, null, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("h3", null, _toDisplayString(f.name), 1),
                                                  _createElementVNode("p", null, _toDisplayString(_ctx.formatFileSize(f.weight)), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_ion_button, {
                                                slot: "end",
                                                fill: "clear",
                                                onClick: ($event: any) => (_ctx.promptRenameFile('guide', f))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                                                ]),
                                                _: 1
                                              }, 8, ["onClick"]),
                                              _createVNode(_component_ion_button, {
                                                slot: "end",
                                                fill: "clear",
                                                color: "danger",
                                                onClick: ($event: any) => (_ctx.confirmDeleteFile('guide', f))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                                ]),
                                                _: 1
                                              }, 8, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }))
                                  : (!_ctx.releaseMediaLoading)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Нет загруженных PDF"))
                                    : _createCommentVNode("", true)
                              ]),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                      _createElementVNode("h2", null, "Обложка", -1),
                                      _createElementVNode("p", null, "Изображение обложки релиза", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.selectFiles('cover')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: _ctx.imageOutline
                                  }, null, 8, ["icon"]),
                                  _cache[58] || (_cache[58] = _createTextVNode(" Загрузить обложку ", -1))
                                ]),
                                _: 1
                              }),
                              _createElementVNode("input", {
                                type: "file",
                                ref: "coverInput",
                                accept: "image/*",
                                style: {"display":"none"},
                                onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.uploadFiles('cover', $event)))
                              }, null, 544),
                              _createElementVNode("div", _hoisted_16, [
                                (_ctx.releaseMediaFiles.cover.length)
                                  ? (_openBlock(), _createBlock(_component_ion_list, {
                                      key: 0,
                                      class: "transparent-list"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.releaseMediaFiles.cover, (f) => {
                                          return (_openBlock(), _createBlock(_component_ion_item, {
                                            key: f.id,
                                            lines: "full"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, null, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("h3", null, _toDisplayString(f.name), 1),
                                                  _createElementVNode("p", null, _toDisplayString(_ctx.formatFileSize(f.weight)), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_ion_button, {
                                                slot: "end",
                                                fill: "clear",
                                                color: "danger",
                                                onClick: ($event: any) => (_ctx.confirmDeleteFile('cover', f))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                                ]),
                                                _: 1
                                              }, 8, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }))
                                  : (!_ctx.releaseMediaLoading)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, "Нет обложки"))
                                    : _createCommentVNode("", true)
                              ]),
                              (_ctx.uploadProgress.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _cache[59] || (_cache[59] = _createElementVNode("h3", null, "Загрузка файлов", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadProgress, (progress, idx) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: 'progress-' + idx,
                                        class: "upload-progress-item"
                                      }, [
                                        _createElementVNode("p", null, _toDisplayString(progress.fileName), 1),
                                        _createVNode(_component_ion_progress_bar, {
                                          value: progress.percent / 100
                                        }, null, 8, ["value"]),
                                        _createElementVNode("p", _hoisted_19, _toDisplayString(progress.status), 1)
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                fill: "outline",
                                color: "danger",
                                class: "ion-margin-top",
                                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.confirmDeleteRelease()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: _ctx.trashOutline
                                  }, null, 8, ["icon"]),
                                  _cache[60] || (_cache[60] = _createTextVNode(" Удалить релиз ", -1))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showLogoModal,
            onDidDismiss: _cache[33] || (_cache[33] = ($event: any) => (_ctx.closeLogoModal())),
            class: "admin-releases-modal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                          _createTextVNode("Логотип программы", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.closeLogoModal()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.logoModalProgram)
                ? (_openBlock(), _createBlock(_component_ion_content, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card, { class: "admin-card" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.logoModalProgram.programName), 1)
                                ]),
                                _: 1
                              }),
                              _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.logoModalProgram.shortName), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              (_ctx.logoModalProgram.shortName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createElementVNode("div", _hoisted_22, [
                                      _createElementVNode("img", {
                                        src: _ctx.programLogoUrl(_ctx.logoModalProgram.shortName),
                                        alt: "Логотип",
                                        class: "program-logo-img",
                                        onError: _cache[29] || (_cache[29] = ($event: any) => (_ctx.onLogoError(_ctx.logoModalProgram.shortName)))
                                      }, null, 40, _hoisted_23)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("input", {
                                type: "file",
                                ref: "logoFileInput",
                                accept: "image/png,image/jpeg,image/jpg",
                                style: {"display":"none"},
                                onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.onLogoFileSelected($event)))
                              }, null, 544),
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.triggerLogoFileInput())),
                                disabled: _ctx.logoUploading
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: _ctx.imageOutline
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString(_ctx.logoUploading ? 'Загрузка...' : 'Выбрать файл (PNG, JPG)'), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              _createVNode(_component_ion_button, {
                                expand: "block",
                                fill: "outline",
                                color: "danger",
                                class: "ion-margin-top",
                                onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.removeProgramLogo())),
                                disabled: _ctx.logoDeleting || !_ctx.logoHasFile(_ctx.logoModalProgram.shortName)
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: _ctx.trashOutline
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString(_ctx.logoDeleting ? 'Удаление...' : 'Удалить логотип'), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["is-open"])
        ]),
        _: 1
      }, 8, ["class", "onIonScroll"])
    ]),
    _: 1
  }))
}